import Vue from 'vue';
import App from './App.vue';
import router from './services/router/router';
import store from './store/store';
import HighchartsVue from 'highcharts-vue';
// import VueGtm from '@gtm-support/vue2-gtm';  temporarily remove until next PR
import './assets/please';
import '../semantic/dist/semantic.min.css';
import 'video.js/dist/video-js.css';

Vue.config.productionTip = false;

// temporarily remove until next PR
// Vue.use(VueGtm, {
//   id: 'GT-5789G2SG',
//   vueRouter: router,
//   debug: false, // Set this to true to see analytics messages for testing. DO NOT COMMIT AS TRUE
// });

Vue.use(HighchartsVue);

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
